import { PageHeader } from '@ant-design/pro-layout';
import { Typography } from 'antd';
import React, { useEffect } from 'react';
import { Link, useMatch, useNavigate, useResolvedPath } from 'react-router-dom';
import { RouteDefinition, VerticalTabs } from '../../../shared/vertical-tabs';
import { SubPageLayout } from '../sub-page-layout';
import { FinanceBatch } from './finance-batch';
import { FinanceDetails } from './finance-details';
import { FinanceSettings } from './finance-settings';

interface FinanceConfigPage {
  id: string;
  path: string;
  title: string;
}

export const FinanceConfig: React.FC = () => {
  const navigate = useNavigate();
  const currentRoutePath = useResolvedPath('').pathname;
  const currentRouteMatch = useMatch(`${currentRoutePath}`);

  const pages: FinanceConfigPage[] = [
    {
      id: '1',
      path: 'settings',
      title: 'Settings'
    },
    {
      id: '2',
      path: 'batch',
      title: 'Finance Batch'
    },
    {
      id: '3',
      path: 'detail',
      title: 'Finance Detail'
    }
  ];

  const routes: RouteDefinition[] = [
    { id: '1', path: 'settings', element: <FinanceSettings /> },
    { id: '2', path: 'batch', element: <FinanceBatch /> },
    { id: '3', path: 'detail', element: <FinanceDetails /> }
  ];

  const configPageNavigationMenu = pages.map((page) => ({
    key: page.id,
    label: <Link to={page.path}>{page.title}</Link>,
    style: { width: '80%' }
  }));

  useEffect(() => {
    if (currentRouteMatch) {
      navigate(routes[0].path); // Redirect to 1st menu item
    }
  }, [currentRouteMatch, navigate]);

  return (
    <SubPageLayout header={<PageHeader title={<Typography.Title className="staff-title">Finance</Typography.Title>} />}>
      <VerticalTabs routes={routes} menuItems={configPageNavigationMenu} />
    </SubPageLayout>
  );
};
